import { useEffect, useState } from 'react';
import { UserData } from '../../model/UserData';
import { LoginData } from '../../model/LoginData';
import { SESSION_KEY } from '../../constants/data';
import { checkExpirationDate } from '../../utils/dateUtils';

export function useLoginData() {
  const [userCache, setUserCache] = useState<UserData | undefined>(undefined);

  useEffect(() => {
    const storedUser = getLocalStorage();

    if (storedUser) {
      if (checkExpirationDate(storedUser.expirationDate)) setUserCache(storedUser);
      else clearLocalStorage();
    }
  }, []);

  function saveUser(userData: UserData) {
    setUserCache(userData);
    saveLocalStorage(userData);
  }

  function logout() {
    setUserCache(undefined);
    clearLocalStorage();
  }

  function updateToken(token?: string, expirationDate?: string) {
    if (token && expirationDate && userCache) {
      setUserCache((current) => {
        const userData = { ...current, token: token, expirationDate: expirationDate };
        saveLocalStorage(userData);
        return userData;
      });
    }
  }

  function isSessionValid() {
    return userCache != null && checkExpirationDate(userCache.expirationDate);
  }

  function subtractPoints(points?: number) {
    if (points && points > 0) {
      setUserCache((current) => {
        if (current?.points == null) return undefined;

        const userData = {
          ...current,
          points: current.points - points,
        };

        saveLocalStorage(userData);

        return userData;
      });
    }
  }

  return {
    user: userCache,
    saveUser: saveUser,
    logoutUser: logout,
    updateToken: updateToken,
    isValid: isSessionValid,
    subtractPoints: subtractPoints,
  } as LoginData;
}

function saveLocalStorage(userData: UserData) {
  try {
    localStorage.setItem(SESSION_KEY, JSON.stringify(userData));
  } catch (error) {}
}

function getLocalStorage(): UserData | undefined {
  var storedValue = null;
  var parsedValue: UserData | undefined = undefined;

  try {
    storedValue = localStorage.getItem(SESSION_KEY);
  } catch (error) {}

  if (storedValue == null) return undefined;

  try {
    parsedValue = JSON.parse(storedValue) as UserData;
  } catch (error) {}
  return parsedValue;
}

function clearLocalStorage() {
  try {
    localStorage.removeItem(SESSION_KEY);
  } catch (error) {}
}
